export default "__VITE_ASSET__BrK5FcOW__"